import { render, staticRenderFns } from "./clause.vue?vue&type=template&id=70e13d04&scoped=true&"
import script from "./clause.vue?vue&type=script&lang=js&"
export * from "./clause.vue?vue&type=script&lang=js&"
import style0 from "./clause.vue?vue&type=style&index=0&id=70e13d04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e13d04",
  null
  
)

export default component.exports